module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point03_01_spectacular_spot-6e4c09e6c805079e74cf0485fe5136d7.jpg";